<template>
  <div class="mt-5 row" v-if="pedido">
    <div class="mx-auto col-12">
      <b-breadcrumb :items="items"></b-breadcrumb>
      <div class="card">
        <div class="card-header">
          <h3>Lista de Exames por Pedido</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <p>
                <strong>Nome do Paciente:</strong>
                {{ usuario }}
              </p>
              <p>
                <strong>Pedido:</strong>
                {{ $store.getters.pedidoSel && $store.getters.pedidoSel.NUPED }}
              </p>
              <p>
                <strong>Data da Coleta:</strong>
                {{ coletaFormatted }}
              </p>
              <p>
                <strong>Unidade de Saúde:</strong>
                {{ unidade }}
              </p>
              <p class="text-right">
                <button class="btn btn-primary" @click="downloadRelatorioTotal()">Imprimir todos os exames</button>
              </p>
            </div>
          </div>
          <b-table
            bordered
            striped
            hover
            responsive
            small
            :busy="isBusy"
            :items="exames"
            :fields="fields"
            class="text-center"
          >
            <!-- <template v-slot:cell(STATUS)="row">
              <font-awesome-icon v-if="['U', 'I'].includes(row.item.STATUS)" icon="circle" class="text-success" />
              <font-awesome-icon v-if="['T', 'P', 'E','L' ,'D', 'A'].includes(row.item.STATUS)" icon="circle" class="text-warning" />
              <font-awesome-icon v-if="row.item.IDREP === 'M'" icon="circle" class="text-danger" />
            </template> -->

            <template v-slot:cell(STATUS)="row">
              <div v-if="['U', 'I'].includes(row.item.STATUS)">
                 <font-awesome-icon v-if="row.item.IDREP !== 'M'" icon="circle" class="text-success" />
              </div>
              <div v-if="['T', 'P', 'E','L' ,'D', 'A'].includes(row.item.STATUS)">
                 <font-awesome-icon v-if="row.item.IDREP !== 'M'" icon="circle" class="text-warning" />
              </div>
              <font-awesome-icon v-if="row.item.IDREP === 'M'" icon="circle" class="text-danger" />
            </template>


            <template v-slot:cell(PREV_RESUL)="row">
              {{ previsaoResultado(row.item) }}
            </template>

            <template v-slot:cell(ACOES)="row">
              <font-awesome-icon 
                v-if="['U', 'I'].includes(row.item.STATUS)" 
                icon="file-pdf" 
                size="lg" 
                class="text-danger pointer"
                data-toggle="tooltip" data-placement="right" title="Baixar exame" 
                @click="abreModal(row.item)"/>
            </template>
            

            <template v-slot:cell(SIT_EXAME)="row">
              {{ situacaoExame(row.item) }}
            </template>

            <template v-slot:cell(IND_EXAME_VISUALIZADO)="row">
              {{ row.item.IND_EXAME_VISUALIZADO }}
            </template>

            <template v-slot:table-busy>
              <div class="text-center my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>
          </b-table>
        </div>
        <div class="card-footer">
          <h5>Legenda</h5>
          <small>
            <p>
              <font-awesome-icon icon="circle" class="text-success" />Liberado (Exame disponível para visualização)
            </p>
            <p>
              <font-awesome-icon icon="circle" class="text-warning" />Aguardando Resultado (Exame em andamento pelo laboratório)
            </p>
            <p>
              <font-awesome-icon icon="circle" class="text-danger" />Recoleta (Não foi possível realizar o exame, necessita de novo material. Procure sua unidade de saúde.)
            </p>

            <p>
              Todos os resultados de exames devem ser avaliados por um profissional de saúde habilitado.
              Retorne para avaliação em sua unidade de saúde.
            </p>
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
moment.locale('pt-br'); 

export default {
  props: {},
  data() {
    return {
      mostraModal: false,
      isBusy: false,
      classRow: "",
      unidade: "",
      usuario: "",
      coleta: "",
      fields: [
        { key: "STATUS", label: "Status" },
        { key: "DSMAT", label: "Material" },
        { key: "DSEXA", label: "Exame" },
        { key: "DSCRM", label: "Profissional Solicitante" },
        { key: "SIT_EXAME", label: "Situação do Exame" },
        { key: "PREV_RESUL", label: "Previsão do Resultado" },
        { key: "IND_EXAME_VISUALIZADO", label: "Visualizado pelo Paciente?" },
        { key: "ACOES", label: "Visualizar Resultado" }
      ],
      items: [
        { text: "Busca pedido", to: { name: "home" } },
        { text: "Lista pedidos", to: { name: "lista-pedidos" } },
        { text: "Lista exames", active: true }
      ]
    };
  },
  computed: {
    pedido() {
      return this.$store.getters.pedidoSel;
    },
    exames() {
      return this.$store.getters.exames;
    },
    http() {
      return this.$store.getters.http;
    },
    coletaFormatted() {
      return this.coleta ? moment(this.coleta).format('llll') : ""
    },
  },
  methods: {
    previsaoResultado(data) {
      let previsao = null
      try {
          previsao = moment(data.dtped).add(data.IDPRZ, 'days').format('llll')
      } catch(err) {
          previsao = moment('0000-00-00')
      }
      return previsao
    },
    situacaoExame(data) {
      //let situacao = data.IDREP === 'M' ? "RECOLETA" : null
      let situacao = (data.IDREP === 'M' && data.STATUS ==='I') ? "RECOLETA" : null
      if(situacao) return situacao

      switch (data.STATUS) {
         case "I":
           situacao = "LIBERADO"
           break;

        case "U":
          situacao = "IMPRESSO"
          break;
      
        case "T":
        case "L":
        case "P":
        case "E":
        case "D":
        case "A":
          situacao = "AGUARDANDO RESULTADO"
          break;
      }
      return situacao
    },
    abreModal(data) {
      this.mostraModal = true
      this.downloadRelatorio(data.NUEXA)
    },
    buscaDados() {
      this.isBusy = true;
      this.$store.dispatch("flushMsgs", "msgs")
      this.$Progress.start();
      this.http
        .get(`/busca-exames/${this.pedido.NUPED}`)
        .then(res => {
          this.$store.dispatch("gravaListaExames", res.data.dados);
          if(res.data.dados[0]) {
            this.unidade = res.data.dados[0].DSUNI
            this.usuario = res.data.dados[0].NOUSU
            this.coleta = res.data.dados[0].dtped
          }
          this.isBusy = false;
          this.$Progress.finish();
        })
        .catch(err => {
          this.isBusy = false;
          const msg = err.message || `Não foi possível recuperar os exames. Tente novamente em instantes.`
          this.$store.dispatch('addErro', {ref: "msgs", msg})
          this.$Progress.fail();
        });
    },
    downloadRelatorio(nuexa) {
      this.$store.dispatch("flushMsgs", "msgs")
      this.$Progress.start();
      const config = {responseType: 'blob'};
      const exame = nuexa || ""
      const nomeArquivo = nuexa || "exames"
      this.http
        .get(`/json/${this.pedido.NUPED}/${exame}`, config)
        .then(res => {
          this.downloadPDF(res.data, nomeArquivo)
          this.buscaDados()
          this.$Progress.finish();
        })
        .catch(err => {
          const msg = err.message || `Não foi possível baixar o exame. Tente novamente em instantes.`
          this.$store.dispatch('addErro', {ref: "msgs", msg})
          this.$Progress.fail();
        });
    },

    downloadRelatorioTotal() {
      this.$store.dispatch("flushMsgs", "msgs")
      this.$Progress.start();
      const config = {responseType: 'blob'};
      const nomeArquivo = "TodosExames"
      this.http
        .get(`/json/${this.pedido.NUPED}`, config)        
        .then(res => {
          this.downloadPDF(res.data, nomeArquivo)
          this.buscaDados()
          this.$Progress.finish();
        })
        .catch(err => {
          const msg = err.message || `Não foi possível baixar o exame. Tente novamente em instantes.`
          this.$store.dispatch('addErro', {ref: "msgs", msg})
          this.$Progress.fail();
        });
    },

    downloadPDF(data, nomeArquivo) {
      let respObj = new Blob([data], { type: 'pdf' });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(respObj);
      link.download = nomeArquivo + ".pdf";
      document.body.appendChild(link);
      link.click();
      link.parentElement.removeChild(link)
    }
  },
  mounted() {
    if (this.pedido) {
      this.buscaDados();
    } else {
      window.location = window.location.protocol + "//" + window.location.host;
    }
    this.$store.dispatch("flushMsgs", "msgs")
  }
};
</script>

<style>
.table-striped tbody tr:hover {
  color: white !important;
  background-color: rgba(40, 167, 69, 0.6) !important;
  cursor: default;
}
.pointer {
  cursor: pointer;
}
</style>